import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { QMAPService, QMAPModule } from "ng-qmap";

import { QMapForm } from "./qmap.form";
import { VasatQMAPService } from "./qmap.service";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
    imports:[
        CommonModule,
        TranslateModule,
        FormsModule,
        QMAPModule
    ],
    declarations:[
        QMapForm
    ],
    exports:[
        QMapForm
    ],
    providers:[
    {
        provide: QMAPService,
        useClass: VasatQMAPService
    }
    ]
})
export class FdmQMAPModule{}